const zh = {
  '济南文越环保工程有限公司': '济南文越环保工程有限公司',
  '首页':'首页',
  '产品':'产品',
  '客户案列':'客户案列',
  '公司介绍':'公司介绍',
  '联系电话':'联系电话',
  '联系邮箱':'联系邮箱',
  '联系地址':'联系地址',
  '了解更多':'了解更多',
  '京ICP备12025439号':'京ICP备12025439号',

  home:{
    '质量第一、客户为本':'质量第一、客户为本',
    '保护生态环境·共创美好家园':'保护生态环境·共创美好家园',
    '在职员工':'在职员工',
    '厂区占地面积':'厂区占地面积',
    '查看更多':'查看更多',
    '联系我们':'联系我们',
    '人':'人',
    '千m²':'千m²',
  },
  login:{
    title:'我是标题',
  }
}
export default zh;
